export default __webpack_public_path__ + "static/media/img-piechart-light.450fee79.svg";